// extracted by mini-css-extract-plugin
module.exports = {"list__bonusToy":"list_list__bonusToy__Eu1br"};